import { render } from "./sideBarMenu.vue?vue&type=template&id=42dc1446&scoped=true"
import script from "./sideBarMenu.vue?vue&type=script&lang=js"
export * from "./sideBarMenu.vue?vue&type=script&lang=js"

import "./sideBarMenu.vue?vue&type=style&index=0&id=42dc1446&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42dc1446"]])

export default __exports__